module.exports = __webpack_public_path__ + "img/36.731526a1.jpg";